export default {
  data() {
    return {
      treeData: [],
    }
  },
  methods: {
    onSelect(checkedKeys, e, index) {
      this[`checkedKeys-${index}`] = checkedKeys
    },
  },
}
